module.exports = __webpack_public_path__ + "static/media/hapticGoRoundImg2.d25ed4d4.jpg";